export default __webpack_public_path__ + "static/media/IMG_9650 copie.eca31a0f.jpg";